import Invoice from 'model/Invoice'

export default class rollDetailCtrl {
    constructor(
        $scope, httpRequest, $state, $stateParams
    ) {
        $scope.isDetail = true
        // 隐藏一二级菜单
        $('#wrapper').addClass('invoiceDetailPage')
        $scope.$on('$stateChangeStart', () => {
            $('#wrapper').removeClass('invoiceDetailPage')
        })
        // 如果是控制台则增加样式
        if ($state.current.name.indexOf('workspace') > -1) {
            $scope.haveBorder = true
        }
        // 如果是已开发票详情
        if ($state.current.name.indexOf('openedInvoice.rollDetail') > -1) {
            $scope.showBillCode = true
        }
        $scope.totalInvoice = 1 // 发票总张数
        $scope.currentInvoice = 1 // 当前张数
        $scope.waitId = $state.params.waitId
        let paramArr = []
        if ($state.params.waitId) {
            paramArr = $state.params.waitId.split('options')
            $scope.waitId = paramArr[0]
            if (paramArr.length > 1) {
                const invoiceArr = JSON.parse(paramArr[1])
                $scope.totalInvoice = invoiceArr.length
                $scope.currentInvoice = invoiceArr.indexOf($scope.waitId) + 1
            }
        }
        $scope.showOperateBtn = function (flag) {
            $scope.showOperate = flag
            if ($scope.currentInvoice > 1 && $scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = true
            } else if ($scope.currentInvoice > 1) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = false
            } else if ($scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = false
                $scope.showOperateRight = true
            }
        }

        $scope.init = async function init() {
            $scope.invoice = new Invoice()
            if ($stateParams.invoiceId || $stateParams.code == 'cancel_invoice_approve' || $stateParams.code == 'reopen_invoice_approve') {
                const invoiceId = $stateParams.invoiceId || $scope.waitId
                const invoiceRes = await httpRequest.post_getOvatInvoice(invoiceId)
                $scope.invoice = new Invoice(invoiceRes.data.value)
            } else if ($scope.waitId) {
                const invoiceRes = await httpRequest.get_queryOvatInvoiceWait({ waitId: $scope.waitId })
                $scope.invoice = new Invoice(invoiceRes.data.value)
            } else {
                $scope.invoice = new Invoice()
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                $scope.invoice.invType = $stateParams.invType
                $scope.invoice.invoiceDate = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00:00`
                if ($state.current.name == 'outputManage.FOManage.invoice.rollTypeInvoiceRedAdd') {
                    $scope.isRed = true
                    $scope.invoice.$isRed = '1'
                }
            }
            const typecodeArr = ['zero_tax']
            $scope.dictionary = {}
            $scope.specList = []
            const disctDataRes = await httpRequest.get_dictByTypeArr(JSON.stringify(typecodeArr))
            Object.assign($scope.dictionary, disctDataRes.data.value)
            $scope.invoice.blueInvoiceCode = ''
            $scope.invoice.blueInvoiceNumber = ''
            // details增加空对象用于绑定项目组件
            $scope.invoice.details.forEach((item) => {
                item.goodsObject = { shortAndMatName: item.shortAndMatName }
            })
            // 初始化buyer对象
            $scope.buyer = $scope.invoice.customer
            $scope.buyer.customerName = $scope.buyer.custName
            $scope.buyer.creditCode = $scope.buyer.custCreditCode
            $scope.version = $scope.invoice.details[0].revenueVersion
            // 初始化发票类型为卷票
            $scope.invoice.invType = '41'
        }
        $scope.init()
        $scope.selectedRows = []
    }
}
rollDetailCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams']



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/rollDetailCtrl.js